export default "__VITE_ASSET__0ef2cf30__"